import { Route } from '@angular/router';

import {
    aroundTheClockLocalGameRoutes,
    aroundTheClockVenueLocalGameRoutes,
} from './games/around-the-clock/local-games-around-the-clock.routes';
import { bobs27LocalGameRoutes, bobs27VenueLocalGameRoutes } from './games/bobs-27/local-games-bobs-27.routes';
import { bullseyeSummitLocalGameRoutes } from './games/bullseye-summit/local-games-bullseye-summit.routes';
import {
    checkout121LocalGameRoutes,
    checkout121VenueLocalGameRoutes,
} from './games/checkout-121/local-games-checkout-121.routes';
import {
    cricketTacticsLocalGameRoutes,
    cricketTacticsVenueLocalGameRoutes,
} from './games/cricket-tactics/local-games-cricket-tactics.routes';
import {
    doublesTrainingLocalGameRoutes,
    doublesTrainingVenueLocalGameRoutes,
} from './games/doubles-training/local-games-doubles-training.routes';
import { halfItLocalGameRoutes, halfItVenueLocalGameRoutes } from './games/half-it/local-games-half-it.routes';
import { killerLocalGameRoutes, killerVenueLocalGameRoutes } from './games/killer/local-games-killer.routes';
import { matchLocalGameRoutes, matchVenueLocalGameRoutes } from './games/match/local-games-match.routes';
import {
    randomCheckoutLocalGameRoutes,
    randomCheckoutVenueLocalGameRoutes,
} from './games/random-checkout/local-games-random-checkout.routes';
import {
    scoreTrainingLocalGameRoutes,
    scoreTrainingVenueLocalGameRoutes,
} from './games/score-training/local-games-score-training.routes';
import {
    shanghaiLocalGameRoutes,
    shanghaiVenueLocalGameRoutes,
} from './games/shanghai/local-games-doubles-training.routes';
import {
    singlesTrainingLocalGameRoutes,
    singlesTrainingVenueLocalGameRoutes,
} from './games/singles-training/local-games-singles-training.routes';

export const localGameRoutes: Route[] = [
    {
        path: 'local-games/practice-games',
        loadComponent: () =>
            import('./pages/app-local-practice-games/app-local-practice-games.component').then(
                (c) => c.AppLocalPracticeGamesComponent
            ),
    },
    {
        path: 'local-games/party-games',
        loadComponent: () => import('./pages/party-games/party-games.component').then((c) => c.PartyGamesComponent),
    },
    ...matchLocalGameRoutes,
    ...aroundTheClockLocalGameRoutes,
    ...bobs27LocalGameRoutes,
    ...cricketTacticsLocalGameRoutes,
    ...doublesTrainingLocalGameRoutes,
    ...scoreTrainingLocalGameRoutes,
    ...shanghaiLocalGameRoutes,
    ...checkout121LocalGameRoutes,
    ...randomCheckoutLocalGameRoutes,
    ...singlesTrainingLocalGameRoutes,
    ...halfItLocalGameRoutes,
    ...bullseyeSummitLocalGameRoutes,
    ...killerLocalGameRoutes,
];

export const venueLocalGameRoutes: Route[] = [
    ...matchVenueLocalGameRoutes,
    ...aroundTheClockVenueLocalGameRoutes,
    ...bobs27VenueLocalGameRoutes,
    ...cricketTacticsVenueLocalGameRoutes,
    ...doublesTrainingVenueLocalGameRoutes,
    ...scoreTrainingVenueLocalGameRoutes,
    ...shanghaiVenueLocalGameRoutes,
    ...checkout121VenueLocalGameRoutes,
    ...randomCheckoutVenueLocalGameRoutes,
    ...singlesTrainingVenueLocalGameRoutes,
    ...halfItVenueLocalGameRoutes,
    ...killerVenueLocalGameRoutes,
    ...bullseyeSummitLocalGameRoutes,
];
